import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toast'
import { Wrapper } from '.'
import { supabase } from '../../../App'
import { setModal } from '../../../redux/modals-reducer'

const Register = () => {
    const dispatch = useDispatch()
    const [registerData, setRegisterData] = useState({
        email: null,
        password: null,
        first_name: null,
        second_name: null,
    })

    const register = async () => {
        const { user, session, error } = await supabase.auth.signUp(
            {
                email: registerData.email,
                password: registerData.password,
            },
            {
                data: {
                    currency: 'USD',
                    first_name: registerData.first_name,
                    second_name: registerData.second_name,
                    seller: 'seller',
                },
            }
        )
        if (user) {
            toast.success('You are registered 👋')
            dispatch(setModal(null))
        }
    }

    return (
        <Wrapper>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                class="ui-g1"
                onClick={(e) => {
                    e.preventDefault()
                    dispatch(setModal(null))
                }}
            >
                <path
                    fill="#000"
                    d="m12 10.586 6.293-6.295a1 1 0 0 1 1.414 1.414L13.414 12l6.293 6.294a1 1 0 1 1-1.414 1.415L12 13.414 5.707 19.71a1 1 0 0 1-1.414-1.415L10.586 12 4.293 5.705a1 1 0 1 1 1.414-1.414L12 10.586Z"
                ></path>
            </svg>
            <img
                src="https://height.app/a/statics/assets/logo.C7N3MDIK.svg"
                alt=""
            />
            <h2>Введите свои данные, чтобы зарегестрироватся</h2>

            <form>
                <div className="input_block">
                    <label>Почта</label>
                    <input
                        type="text"
                        onChange={(e) =>
                            setRegisterData({
                                ...registerData,
                                email: e.target.value,
                            })
                        }
                        value={registerData.email}
                    />
                </div>
                <div className="input_block">
                    <label>Имя</label>
                    <input
                        type="text"
                        onChange={(e) =>
                            setRegisterData({
                                ...registerData,
                                first_name: e.target.value,
                            })
                        }
                        value={registerData.first_name}
                    />
                </div>
                <div className="input_block">
                    <label>Фамилия</label>
                    <input
                        type="text"
                        onChange={(e) =>
                            setRegisterData({
                                ...registerData,
                                second_name: e.target.value,
                            })
                        }
                        value={registerData.second_name}
                    />
                </div>
                <div className="input_block">
                    <label>Пароль</label>
                    <input
                        type="password"
                        onChange={(e) =>
                            setRegisterData({
                                ...registerData,
                                password: e.target.value,
                            })
                        }
                        value={registerData.password}
                    />
                </div>
                <button
                    className="submit"
                    onClick={(e) => {
                        e.preventDefault()
                        register()
                    }}
                >
                    Зарегестрироваться
                </button>
            </form>
            <p
                className="bottom_text"
                onClick={(e) => {
                    e.preventDefault()
                    dispatch(setModal('AUTH'))
                }}
            >
                Уже зарегестрированы?
            </p>
        </Wrapper>
    )
}

export default Register
